import { useStaticQuery, graphql } from 'gatsby';

export const useAllPosts = () => {
    const {
        allWpPost: { nodes: posts }
    } = useStaticQuery(graphql`
        query {
            allWpPost(sort: { date: DESC }) {
                nodes {
                    id
                    title
                    excerpt
                    uri
                    categories {
                        nodes {
                            id
                        }
                    }
                    featuredImage {
                        node {
                            id
                            altText
                            sourceUrl
                            localFile {
                                childImageSharp {
                                    gatsbyImageData(aspectRatio: 1.4)
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return posts;
};
